// extracted by mini-css-extract-plugin
export default {"tooltip":"RTTooltip-tooltip-1Rty5"};